import { Injectable } from '@angular/core';

@Injectable()
export class AddressAutocompleteModel {

    public id: string;

    public enabled = true; //use CA autocomplete form or not
    public displayEdit = false; //display FULL form or not

    public country: number;
    public city: string;
    public province: string;
    public postalCode: string;
    public address: string;
    public address2: string;

    public addressInline = '';

    /* added for settings tab in account page */
    public lastName: string;
    public firstName: string;
    public phone = ''; //obsolete?

    public countryRegion = new CountryRegion();

    public countryName: string;
    public provinceName: string;
}

class CountryRegion {
    public code: string;
    public country = new Country();
    public countryId: Number;
    public id: Number;
    public name: string;
}

class Country {
    public id: Number;
    public iso2: string;
    public iso3: string;
    public name: string; //full name
}


// WEBPACK FOOTER //
// ./src/custom_modules/autocomplete/address-autocomplete.model.ts